module.exports = __webpack_public_path__ + "static/color_keyboard-6e1fffb92c212e2447469b2ad0cd6bfb.jpg";